<div class="card-actions">
    <h3>{{heading}}</h3>
    <div (click)="onClose()" title="Close" class="close">
      <mat-icon>close</mat-icon>
    </div>
  </div>